module.exports = $svjq;